import { useMemo } from 'react';

import { defaultColumn, defaultColumnId } from '@Components/Grid/utils/column';
import { formatDate } from '@Utils/index';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('key', 'Key'),
    defaultColumn('created_at', 'Created At', info => formatDate(info.getValue(), 'MMM DD, YYYY - hh:mm A')),
  ], [])
}
